import { Component } from '@angular/core';

@Component({
  selector: 'sbd-account-portal-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Account Portal';
  constructor() {
    //
  }
}
